import { agentRoutes } from "@/src/routes/private/agent.routes.tsx";
import { DashboardLayout } from "@core/presentation/components/layout/dashboard-layout/dashboard.layout.tsx";
import { ErrorInRoute } from "@core/presentation/components/routing/error-in-route/error-in-route.component.tsx";
import { LoginFromTokenGuard } from "@core/presentation/components/routing/login-from-token/login-from-token.guard.tsx";
import { MissingRoute } from "@core/presentation/components/routing/missing-route/missing-route.component.tsx";
import { RequireAuthGuard } from "@core/presentation/components/routing/require-auth/require-auth.guard.tsx";
import { adminRoutes } from "@routes/private/admin.routes.tsx";
import { campaignRoutes } from "@routes/private/campaign.routes.tsx";
import { customGraphRoutes } from "@routes/private/custom-graph.routes.tsx";
import { farmRoutes } from "@routes/private/farm.routes.tsx";
import { homeRoutes } from "@routes/private/home.routes.tsx";
import { notebookRoutes } from "@routes/private/notebook.routes.tsx";
import { reportRoutes } from "@routes/private/report.routes.tsx";
import { stationRoutes } from "@routes/private/station.routes.tsx";
import { weatherRoutes } from "@routes/private/weather.routes.tsx";
import { loginRoutes } from "@routes/public/login.routes";
import {
    createBrowserRouter,
    createRoutesFromElements,
    Route,
} from "react-router";
import { App } from "../app.tsx";

const routes = (
    <Route
        element={<App />}
        errorElement={<ErrorInRoute />}
    >
        {/* PUBLIC ROUTES */}
        <Route element={<LoginFromTokenGuard />}>
            {/* ADD PUBLIC ROUTES HERE */}
            {loginRoutes}
        </Route>

        {/* PRIVATE ROUTES */}
        <Route element={<RequireAuthGuard />}>
            <Route element={<DashboardLayout />}>
                <Route
                    lazy={async () => {
                        const { RootModuleLayout } =
                            await import("@core/presentation/components/layout/module-layout/root-module.layout.tsx");
                        return { Component: RootModuleLayout };
                    }}
                >
                    {/* ADD PRIVATE ROUTES HERE */}
                    <Route errorElement={<ErrorInRoute />}>
                        {homeRoutes}
                        {stationRoutes}
                        {weatherRoutes}
                        {notebookRoutes}
                        {campaignRoutes}
                        {reportRoutes}
                        {adminRoutes}
                        {agentRoutes}
                        {farmRoutes}
                        {customGraphRoutes}
                    </Route>
                </Route>
            </Route>
        </Route>

        {/* MISSING ROUTE */}
        <Route
            path={"*"}
            element={<MissingRoute />}
        />
    </Route>
);

export const router = createBrowserRouter(createRoutesFromElements(routes));
